export default __webpack_public_path__ + "static/MS-Votes-logo-white-77b41f04d081663fe6d2b4cefc35aca3.png";